import { format, parseISO, isValid, getTime } from 'date-fns'

export const formatTimeString = (timeString: string, formatString: string = 'MMM d, HH:mm'): string | null => {
  if (!timeString) return null

  try {
    const date = parseISO(timeString)
    if (!isValid(date)) {
      return null
    }

    return format(date, formatString)
  } catch (error) {
    console.error('Error formatting time:', error)
    return null
  }
}

export const getUtcTimestampByTime = (timeString: string): number | null => {
  if (!timeString) return null

  try {
    const date = parseISO(timeString)
    if (!isValid(date)) {
      return null
    }

    return getTime(date) / 1000
  } catch (error) {
    console.error('Error parsing time:', error)
    return null
  }
}

export const getDeclension = (count: number, titles: { default: string; one: string; some: string }): string => {
  const count_part = count % 10

  if (count >= 11 && count <= 19) {
    return `${count} ${titles.default}`
  } else if (count_part === 1) {
    return `${count} ${titles.one}`
  } else if ([2, 3, 4].includes(count_part)) {
    return `${count} ${titles.some}`
  } else {
    return `${count} ${titles.default}`
  }
}

export const formatHoursTitle = (hours: number): string => {
  return getDeclension(hours, {
    default: 'hours',
    one: 'hour',
    some: 'hours',
  })
}

export function formatDaysTitle(days: any) {
  return getDeclension(days, {
    default: 'days',
    one: 'day',
    some: 'days',
  })
}

export function formatMonthTitle(days: any) {
  return getDeclension(days, {
    default: 'months',
    one: 'month',
    some: 'months',
  })
}

export const formatMinutesTitle = (minutes: number): string => {
  return getDeclension(minutes, {
    default: 'minutes',
    one: 'minute',
    some: 'minutes',
  })
}

export function formatServerDate(input: string | number, locale: string | undefined = undefined): string {
  if (!input) return ''
  let date: Date

  if (typeof input === 'number') {
    date = new Date(input)
  } else {
    const iso = input.replace(' ', 'T')
    date = new Date(iso)
  }

  if (isNaN(date.getTime())) {
    return ''
  }

  return new Intl.DateTimeFormat(locale, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    year: 'numeric',
    hour12: false,
  }).format(date)
}

export const isLeapCurrentYear = (): boolean => {
  const y = new Date().getFullYear()
  return (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0
}
